/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

//---------------------------------------------------------------------
// Colour can only be used with the first param of a call to console.*
//     (log, info, debug, etc)
//     Example: only string1 will work with color
//     $ console.debug(string1, string2, object3)
//---------------------------------------------------------------------

export const addColor = (colorCode, message) => {
    const open = `\u001b[${colorCode}m`;
    const close = "\u001b[0m";
    return `${open}${message}${close}`;
};

export const stripAnsiCodes = (message) => {
    // eslint-disable-next-line no-control-regex
    return message.replace(/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, "");
};

export const colors = {
    black: "30",
    red: "31",
    green: "32",
    yellow: "33",
    blue: "34",
    magenta: "35",
    cyan: "36",
    white: "37",
    gray: "90",
    grey: "90",
    blackBright: "90",
    redBright: "91",
    greenBright: "92",
    yellowBright: "93",
    blueBright: "94",
    magentaBright: "95",
    cyanBright: "96",
    whiteBright: "97"
};

// Ansi Color wrapping is disabled when the console is enabled
export const black = (message) => addColor(colors.black, message);
export const red = (message) => addColor(colors.red, message);
export const green = (message) => addColor(colors.green, message);
export const yellow = (message) => addColor(colors.yellow, message);
export const blue = (message) => addColor(colors.blue, message);
export const magenta = (message) => addColor(colors.magenta, message);
export const cyan = (message) => addColor(colors.cyan, message);
export const white = (message) => addColor(colors.white, message);
export const gray = (message) => addColor(colors.gray, message);
export const grey = (message) => addColor(colors.grey, message);
export const blackBright = (message) => addColor(colors.blackBright, message);
export const redBright = (message) => addColor(colors.redBright, message);
export const greenBright = (message) => addColor(colors.greenBright, message);
export const yellowBright = (message) => addColor(colors.yellowBright, message);
export const blueBright = (message) => addColor(colors.blueBright, message);
export const magentaBright = (message) => addColor(colors.magentaBright, message);
export const cyanBright = (message) => addColor(colors.cyanBright, message);
export const whiteBright = (message) => addColor(colors.whiteBright, message);
